import DatastoreTypeHandler from './DatastoreTypeHandler'

export default class ApiDatastoreHandler extends DatastoreTypeHandler {
  constructor() {
    super('api')
  }

  applyTypeDefaults(data, set) {
    super.applyTypeDefaults(data, set)
    if (data.api == null) set('api', '')
  }

  validateCreate(data) {
    if (!data.api) {
      return {
        ok: false,
        errors: { api: ['Link API không thể bỏ trống'] },
      }
    }
    return { ok: true, errors: {} }
  }

  buildCreatePayload(data, context = {}) {
    const payload = super.buildCreatePayload(data, context)
    payload.api = data.api
    return payload
  }
}
